import styled from "styled-components";

export const Container = styled.aside`
	@media screen and (min-width: 0px) {
		background-color: var(--white);
		position: sticky;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 56px;
		z-index: 1000;
		box-shadow: 0px -4px 15px 3px rgba(0, 0, 0, 0.1);

		nav {
			ul {
				list-style: none;
				padding: 0;
				display: flex;
				justify-content: space-around;
				align-items: center;
				height: 100%;

				li {
					a {
						display: block;

						&:hover svg {
							& path {
								stroke: #f7a51b;
							}
						}
					}
				}

				li:nth-of-type(3) {
					a:hover {
						svg {
							fill: #f7a51b !important;
							stroke: #f7a51b;
						}
					}
				}

				li:nth-of-type(4) {
					a:hover {
						svg path {
							fill: #f7a51b !important;
							stroke: #f7a51b;
						}
					}
				}
			}

			img.logo-labyes {
				display: none;
			}
		}
	}

	@media screen and (min-width: 992px) {
		max-width: 130px;

		nav {
			display: flex;
			flex-direction: column;
			height: 100%;

			ul {
				margin: 0;
				flex-direction: column;
				height: 100%;

				// TODO para funciona precisa troca os icones problematicos
				/* li {
                    a {
                        svg {
                            width: 40px;
                            height: 40px;
                        }
                    }
                } */
			}

			img.logo-labyes {
				display: block;
				width: 100%;
				max-width: 70%;
				margin: 0 auto;
				margin-bottom: 15px;
			}
		}
	}
`;
